import { executePost } from "../../../Utils/ServiceMethods";
import { setUserCredentials } from "../../../Utils/LocalStorage";
import { toast } from "react-toastify";
import { SessionTimeout } from "../../../Utils/ErrorMessages";
import { removeUserCredentials } from "../../../Utils/LocalStorage";

export const LoginUser = async (LoginCredentials, cb) => {
  try {
    const UserLogin = await executePost("/signin", LoginCredentials);
    const UserLoginData = UserLogin.data ? UserLogin.data : {};
    setUserCredentials(UserLoginData);
    return UserLoginData;
  } catch (err) {
    if (err.response.data.message === "Token is invalid!") {
      toast.dismiss();
      toast.clearWaitingQueue();
      toast.error(SessionTimeout, {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      removeUserCredentials();
      if (cb) {
        cb();
      }
    } else {
      return false;
    }
  }
};
